import { render, staticRenderFns } from "./formMyTask.vue?vue&type=template&id=5fa9da5e&"
import script from "./formMyTask.vue?vue&type=script&lang=js&"
export * from "./formMyTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports